var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 6V2H14V6H8.66667ZM2 8.66667V2H7.33333V8.66667H2ZM8.66667 14V7.33333H14V14H8.66667ZM2 14V10H7.33333V14H2ZM3.33333 7.33333H6V3.33333H3.33333V7.33333ZM10 12.6667H12.6667V8.66667H10V12.6667ZM10 4.66667H12.6667V3.33333H10V4.66667ZM3.33333 12.6667H6V11.3333H3.33333V12.6667Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDashboard);
export default __webpack_public_path__ + "static/media/icons-dashboard.dd38d7f3.svg";
export { ForwardRef as ReactComponent };